import { openkit } from "../../library/database";

export const addGoodsToCart = async (
  product,
  info,
  quantity = 1,
  deliveryVillage,
  clientRequest,
  setAddedToCart
) => {
  const cartItem = {
    type: "goods",
    product_id: product.id,
    client_id: info.user.id,
    request: clientRequest,
    quantity: quantity,
    goo_delivery_village: deliveryVillage,
  };

  await openkit.data.create("c_reservation_lines", cartItem);
  setAddedToCart(true);
};
